import MainLayout from "@/components/layout/admin/MainLayout.vue";
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import CONFIG from "@/assets/js/config.js";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import Select2Multiple from 'v-select2-multiple-component';
import axios from "axios";
import {
  required,
  maxLength
} from "vuelidate/lib/validators";
import ValidationService from "@/services/ValidationService";
import store from '@/store';

export default {
  name: "termEdit",
  components: {
    MainLayout,
    flatPickr,
    Loading,
    Select2Multiple,
  },

  mixins: [ValidationService],

  data() {
    return {
      termData: {
        acd_year_id: 0,
        term_name: '',
        start_date: '',
        end_date: '',
        login_id: store.state.user.id
      },
      submitted: false,
      isLoading: false,
      disabled: false,
      isError: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      academicYearArr: [],
      acdYearStart: null,
      acdYearEnd: null,
      acdYearId: this.$route.params.acdYearId ? Number(this.$route.params.acdYearId) : 0,
    };
  },

  validations: {
    termData: {
      term_name: {
        required,
        maxLength: maxLength(255)
      },
      start_date: {
        required
      },
      end_date: {
        required
      }
    },
  },

  watch: {
    "termData.start_date"() {
      this.validationErrors.end_date = [];
    },

    "termData.end_date"() {
      this.validationErrors.end_date = [];
    }
  },

  methods: {
    getDetail() {
        axios.get(`period/${this.acdYearId}/term/detail/${this.$route.params.id}`)
            .then(res => {
                if (res.data) {
                    this.termData = res.data.term;
                }
                this.isLoading = false;
            })
            .catch(error => {
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
                this.isLoading = false;
            })
    },

    update() {
        if (this.disabled) return;
        this.submitted = true;
        if (this.termData.start_date && this.termData.end_date && new Date(this.termData.end_date) <= new Date(this.termData.start_date)) {
            this.isError = true;
        } else {
            this.isError = false;
        }

        if (this.$v.$invalid || this.isError) {
            this.disabled = false;
            return;
        }

        this.disabled = true;
        this.termData.login_id = this.$store.state.user.id;
        axios.patch(`period/${this.acdYearId}/term/update/${this.$route.params.id}`, this.termData)
            .then(res => {
                if (res.status == 200) {
                    this.$notification.success("Term Updated Successfully", {
                        timer: 3,
                        position: "bottomCenter"
                    });
                    this.$router.push({
                        name: "periodDetail",
                        params: { id: this.acdYearId }
                    });
                } else {
                    this.disabled = false;
                    this.$notification.error(res.data.message, {
                        timer: 3,
                        position: "bottomCenter",
                    });
                }
            })
            .catch(error => {
                this.disabled = false;
                this.isLoading = false;
                this.printValidationError(error.response);
                if (error.response.status == 401) {
                    this.$store.commit('logout');
                    window.location.replace('login');
                }
            })
      }
    },

    mounted() {
        this.isLoading = true;
        this.getDetail();
    },
};
